import { Pipe, PipeTransform } from '@angular/core';
import { RunTicket } from '../../_models/field';

@Pipe({ name: 'tankFilter' })

export class TankFilterPipe implements PipeTransform {
  transform(tickets: RunTicket[], selectTanks: any[]): any[] {
    if (!tickets) return [];
    if (selectTanks.length == 0) return tickets;

    return tickets.filter(ticket => {
      if (selectTanks.includes(ticket.tankID)) {
        return ticket;
      }
    });
  }
}
